import {filterMenuWithOrder, filterBreadcrumb} from '@/utils/common'
import config from '@/config'

export default {
  permissions: state => {
    if('userInfo' in state) {
      return state.userInfo.permissions.map(item => item.codename)
    } else {
      return []
    }
  },
  groups: state => {
    if('groups' in state) {
      return state.userInfo.groups
    } else {
      return []
    }
  },
  allMenus: (state, getters) => {
    return filterMenuWithOrder(config.menu, getters.permissions)
  },
  zhixiaoyun: state => {
    return state.zhixiaoyunBridge
  },
  allSubMenus: (state, getters) => {
    if(state.menu.length > 0) {
      let menu = getters.allMenus.find(item => item.code === state.menu[0])
      if(menu) {
        let subMenu = menu.subMenu || []
        let permissions = getters.permissions
        return subMenu.filter(menu => permissions.indexOf(menu.code) >= 0)
      } else {
        return []
      }
    }
    return []
  },
  allBreads: (state, getters) => {
    return filterBreadcrumb(config.breadcrumb, getters.permissions)
  },
  symptomsDict: (state, getters) => {
    return state.medcase.symptoms.reduce((acc, item) =>{
      acc[item.id] = item;
      return acc
    }, {})
  }
}
